// extracted by mini-css-extract-plugin
var _1 = "RentalPortalListingProfileDescriptionWidget-modulefields__JGrwY FormFieldsContainer-moduleFormFieldsContainer__u1JJu";
var _2 = "RentalPortalListingProfileDescriptionWidget-moduleformBody__Yi6Yn";
export { _1 as "fields", _2 as "formBody" }
